module.exports = __webpack_public_path__ + "static/media/program-antyplagiatowy-wrona-3.d4361886.webp";